'use client'

/**
 * Theme loader - now handled by /public/theme-init.js
 * This file is kept for backwards compatibility but logic is consolidated
 */

export function ThemeLoader() {
  // No-op - theme is now loaded via external script in layout.tsx
  return null
}

/**
 * Apply stored theme - fallback for SSR scenarios
 * Main logic is in /public/theme-init.js
 */
export function applyStoredTheme() {
  // Check if already initialized by inline script
  if (typeof window !== 'undefined' && (window as any).__OXIGEN_THEME_INITIALIZED__) {
    return
  }
  
  // For SSR fallback, reload the theme-init script
  if (typeof window !== 'undefined') {
    const script = document.createElement('script')
    script.src = '/theme-init.js'
    document.head.appendChild(script)
  }
}
